import React from 'react';
import { useController } from 'react-hook-form/dist/index.ie11';
import { startOfDay } from 'date-fns';
import { DATE_PLACEHOLDER } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { DatePickerInput } from 'src/components/DatePickerInput/DatePickerInput';
import { DatePickerWrapperProps } from 'src/components/DatePickerInput/datePickerWrapperProps';

export const DATE_PICKER_DATE_FORMAT = 'eee MMM dd yyyy';

export const DateRangeInput = ({
  control,
  rules = {},
  name,
  error,
  disabledDays,
  initialMonth,
  disabled = false,
  blockWidth = false,
  placeholder = `${DATE_PLACEHOLDER}-${DATE_PLACEHOLDER}`,
  ...rest
}: DatePickerWrapperProps): JSX.Element => {
  const {
    field: { value, onChange },
  } = useController({
    name,
    rules,
    control,
    defaultValue: control.defaultValuesRef.current[name] ?? '',
  });

  return (
    <DatePickerInput
      {...rest}
      name={name}
      error={error}
      disabled={disabled}
      blockWidth={blockWidth}
      isRangeSelection
      forceMonthsToWrap
      initialDateRange={value}
      dayPickerProps={{
        ...(disabledDays && { disabledDays }),
        ...(initialMonth && { month: initialMonth }),
        numberOfMonths: 1,
      }}
      useFullScreenOverlay={false}
      placeholder={placeholder}
      onDateChange={(startDate: Date, endDate?: Date): void => {
        onChange({
          from: startDate ? startOfDay(startDate) : undefined,
          to: endDate ? startOfDay(endDate) : undefined,
        });
      }}
    />
  );
};
